import { 
  lhvContract,
  usdtContract,
  safeContract, lhvConAdd

        } from "./ConAddsAndABIs"
import { ethers } from "ethers";
import React, { useEffect, useState } from "react";

function TheLoyalHodlersVault(){

const [walletAddress, setWalletAddress] = useState(""); //<<<<

const [totalNumberOfLoyalHodlers, setTotalNumberOfLoyalHodlers] = useState('');
const [totalClaimants, setTotalClaimants] = useState('');
const [totalUsdtRewards, setTotalUsdtRewards] = useState('');
const [totalClaimedRewards, setTotalClaimedRewards] = useState('');
const [forfeitedSafe, setForfeitedSafe] = useState('');

const [loyalHoldingStatus, setLoyalHoldingStatus] = useState('');
const [buttonForLHRegistration3, setButtonForLHRegistration3] = useState('');
const [buttonForLHRegistration2, setButtonForLHRegistration2] = useState('');
const [buttonForLHRegistration1, setButtonForLHRegistration1] = useState('');

const [resignationStatus, setResignationStatus] = useState('');
const [buttonForResignation, setButtonForResignation] = useState('');
const [buttonForEarlyResignation, setButtonForEarlyResignation] = useState('');
const [yearsLocked, setYearsLocked] = useState('');
const [yearsLockedUntil, setYearsLockedUntil] = useState('');
const [rewardsEarned, setRewardsEarned] = useState('');
const [rewardsClaimed, setRewardsClaimed] = useState('');
const [rewardsClaimable, setRewardsClaimable] = useState('');
const [buttonForClaiming, setButtonForClaiming] = useState('');
const [penalty, setPenalty] = useState('');
const [stakedAmount, setStakedAmount] = useState('');

useEffect(() => {  
 
    const getWalletAddress = async () => {
      const accounts = await window.ethereum.request({
          method: "eth_requestAccounts",
      });
      const account = accounts[0]
      const accountF = account.toString()
      setWalletAddress(accountF);
    }

      getWalletAddress()
        .catch(console.error)  

// - - - - - - - - - - 
    const getTotalNumberOfLoyalHodlers = async () => {
      const data = await lhvContract.numberOfLoyalHodlers()
      const dataF = data.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
        setTotalNumberOfLoyalHodlers(dataF)
    }  

    getTotalNumberOfLoyalHodlers()
    .catch(console.error)   

// - - - - - - - - - - 
const getTotalClaimants = async () => {
    const data = await lhvContract.totalClaimants()
    const dataF = data.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    setTotalClaimants(dataF)
  }  

  getTotalClaimants()
  .catch(console.error)

// - - - - - - - - - - 
const getTotalUsdtRewards = async () => {
    const x = await lhvContract.totalClaimedRewards() / (10**6);
    const y = await usdtContract.balanceOf(lhvConAdd) / (10**6);
    const z = x + y;
    const data = z.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    setTotalUsdtRewards(data)
  }  

  getTotalUsdtRewards()
  .catch(console.error)

// - - - - - - - - - - 
const getTotalClaimedRewards = async () => {
    const x = await lhvContract.totalClaimedRewards() / (10**6);
    const y = x.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    setTotalClaimedRewards(y)
  }  

  getTotalClaimedRewards()
  .catch(console.error)

// - - - - - - - - - - 
const getForfeitedSafe = async () => {
    const x = await lhvContract.forfeitedSafe() / (10**18);
    const a = x.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    setForfeitedSafe(a)
  }  

  getForfeitedSafe()
  .catch(console.error)  

// - - - - - - - - - - 
const getLoyalHoldingStatus = async () => {
    const x = await lhvContract.isLoyalHoder(walletAddress);
    if (x === false) {
        setLoyalHoldingStatus("Not a Loyal Hodler")
        setButtonForLHRegistration3(<button onClick={handleButtonForLHRegistration3}>3 Yrs</button>)
        setButtonForLHRegistration2(<button onClick={handleButtonForLHRegistration2}>2 Yrs</button>)
        setButtonForLHRegistration1(<button onClick={handleButtonForLHRegistration1}>1 Yr</button>)

    } else if (x === true) {
        setLoyalHoldingStatus("Loyal Hodler") 
    }
    
  }  

  getLoyalHoldingStatus()
  .catch(console.error)  

// - - - - - - - - - - 
const getResignationStatus = async () => {
    const a = await lhvContract.isLoyalHoder(walletAddress);
    const b = a.toString();    
    const c = await lhvContract.isResigned(walletAddress);
    const d = c.toString();
    const e = await lhvContract.lockedUntil(walletAddress);
    const f = new Date(e * 1000);
    const g = f.toString()
    const timeNow = new Date()
    const h = await lhvContract.yearsLocked(walletAddress);
    const i = h.toString()
    const j = await lhvContract.getClaimableRewards(walletAddress) / (10**6);
    const k = j.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    const l = await lhvContract.rewardsClaimed(walletAddress) / (10**6);
    const m = l.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    const o = j + l;
    const p = o.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    const q = await lhvContract.getYrsLockedRem(walletAddress) / 1 + 1
    const r = q * 1000000
    const s = r.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})

    setPenalty(s)
    if (b === "false" && d === "false") {
        setResignationStatus("Not a Loyal Hodler")
    } else if (b === "true" && d === "false" && timeNow < f) {
        setResignationStatus("Active")
        
        setButtonForEarlyResignation(<button onClick={handleEarlyResignation}>Resign Early For A Penalty For {penalty} $SAFE </button>)
        setYearsLocked(i)
        setYearsLockedUntil(g)
        setRewardsEarned(p)
        setRewardsClaimed(m)
        setRewardsClaimable(k)
        setStakedAmount("10,000,000 $SAFE")
    } else if (b === "true" && d === "false" && timeNow >= f) {
        setResignationStatus("Active")
        setButtonForResignation(<button onClick={handleResignation}>Resign Without Penalty</button>)
        setYearsLocked(i) 
        setYearsLockedUntil(g)
        setRewardsEarned(p)
        setRewardsClaimed(m)
        setRewardsClaimable(k)     
        setStakedAmount("10,000,000 $SAFE") 
    } else if (b === "true" && d === "true") {
        setResignationStatus("Resigned")  
        setRewardsEarned(p)


    }
    
  }  

  getResignationStatus()
  .catch(console.error)  

// - - - - - - - - - - 
const getButtonForClaiming = async () => {
    const a = await lhvContract.getClaimableRewards(walletAddress) / (10 ** 18);

    if (a === 0) {
        setButtonForClaiming()
    } else {
        setButtonForClaiming(<button onClick={handleButtonForClaiming}>Claim Rewards</button>)
    }
    
  }  

  getButtonForClaiming()
  .catch(console.error) 

})

const handleButtonForLHRegistration3 = async (e) => {
    e.preventDefault();
    const safeAllow = '10000000'
    console.log(safeAllow)
    const uintValue = ethers.utils.parseUnits(safeAllow, 18)
    const txna = await safeContract.approve(lhvConAdd, uintValue) 
    await txna.wait();
    const txnb = await lhvContract.applyLoyalHodler("3")
    await txnb.wait();
    } 

const handleButtonForLHRegistration2 = async (e) => {
    e.preventDefault();
    const safeAllow = '10000000'
    console.log(safeAllow)
    const uintValue = ethers.utils.parseUnits(safeAllow, 18)
    const txna = await safeContract.approve(lhvConAdd, uintValue) 
    await txna.wait();
    const txnb = await lhvContract.applyLoyalHodler("2")
    await txnb.wait();
    } 

const handleButtonForLHRegistration1 = async (e) => {
    e.preventDefault();
    const safeAllow = '10000000'
    console.log(safeAllow)
    const uintValue = ethers.utils.parseUnits(safeAllow, 18)
    const txna = await safeContract.approve(lhvConAdd, uintValue) 
    await txna.wait();
    const txnb = await lhvContract.applyLoyalHodler("1")
    await txnb.wait();
    } 

const handleResignation = async (e) => {
    e.preventDefault();
    const txn = await lhvContract.resignLoyalHodler()
    await txn.wait();
    } 

const handleEarlyResignation = async (e) => {
    e.preventDefault();
    const txn = await lhvContract.earlyResignLoyalHodler()
    await txn.wait();
    } 

const handleButtonForClaiming = async (e) => {
    e.preventDefault();
    const txn = await lhvContract.claimRewards()
    await txn.wait();
    } 

return ( 
  <div>
      <h2>The Loyal Hodlers' Vault</h2><br/>

      <table className="tableA">
        <tbody>
            <tr>
                <th style={{"width": "75%"}}>Global Metrics</th>
                <th style={{"width": "25%"}}>Stats</th>
            </tr>
            <tr>
                <td>Total Number of Loyal Hodlers</td>
                <td className="column2">{totalNumberOfLoyalHodlers}</td>
            </tr>
            <tr>
                <td>Total Number of Participations</td>
                <td className="column2">{totalClaimants}</td>
            </tr>   
            <tr>
                <td>Total USDC Rewards</td>
                <td className="column2">{totalUsdtRewards}</td>
            </tr>   
            <tr>
                <td>Total USDC Claimed</td>
                <td className="column2">{totalClaimedRewards}</td>
            </tr>        
            <tr>
                <td>Total Safe Forfeited</td>
                <td className="column2">{forfeitedSafe}</td>
            </tr>                                                                                                                                
        </tbody>               
      </table><br />

      <table className="tableA">
        <tbody>
            <tr>
                <th style={{"width": "75%"}}>Personal Metrics</th>
                <th style={{"width": "25%"}}>Stats</th>
            </tr>
            <tr>
                <td>Loyal Hodlers Status  
                    {buttonForLHRegistration3} 
                    {buttonForLHRegistration2} 
                    {buttonForLHRegistration1}</td>
                <td className="column2">{loyalHoldingStatus}</td>
            </tr>
            <tr>
                <td>Resignation Status {buttonForEarlyResignation}
                    {buttonForResignation}</td>
                <td className="column2">{resignationStatus}</td>
            </tr>   
            <tr>
                <td>Amount Staked</td>
                <td className="column2">{stakedAmount}</td>
            </tr>              
            <tr>
                <td>Years Locked</td>
                <td className="column2">{yearsLocked}</td>
            </tr>  
            <tr>
                <td>Remaining Years Locked</td>
                <td className="column2">{yearsLocked}</td>
            </tr>             
            <tr>
                <td>Locked Until</td>
                <td className="column2">{yearsLockedUntil}</td>
            </tr> 
            <tr>
                <td>Rewards</td>
                <td className="column2">{rewardsEarned}</td>
            </tr>  
            <tr>
                <td>Rewards Claimed</td>
                <td className="column2">{rewardsClaimed}</td>
            </tr>  
            <tr>
                <td>Rewards Claimable {buttonForClaiming}</td>
                <td className="column2">{rewardsClaimable}</td>
            </tr>                                                                                                                                     
        </tbody>               
      </table><br />    


  </div>
  
)

}


export default TheLoyalHodlersVault;